import { uniq } from 'lodash';

import {
  type BaseLeaderboardColumn,
  isColumnExportable,
  type LeaderboardGrouping,
} from '@neptune/shared/leaderboard-domain';

import { KnownAttributes } from 'domain/experiment/attribute';

const REQUIRED_LEADERBOARD_ATTRIBUTES = [
  KnownAttributes.Id,
  KnownAttributes.Name,
  KnownAttributes.ExperimentIsHead,
  KnownAttributes.CreationTime,
  KnownAttributes.ModificationTime,
  KnownAttributes.CustomRunId,
  KnownAttributes.YodaUrl,
  KnownAttributes.Archived,
  KnownAttributes.State,
  KnownAttributes.Failed,
  KnownAttributes.DiagnosticsAttributesLimitsTotalCountExceeded,
  KnownAttributes.DiagnosticsAttributesLimitsFloatSeriesCountExceeded,
  KnownAttributes.DiagnosticsDroppedFloatSeriesCount,
];

export function getEntityLeaderboardAttributesToFetch({
  columns,
  grouping,
}: {
  columns: ReadonlyArray<Pick<BaseLeaderboardColumn, 'id'>>;
  grouping?: LeaderboardGrouping;
}): string[] {
  return uniq([
    ...REQUIRED_LEADERBOARD_ATTRIBUTES,
    ...(grouping?.groupBy ?? []).map(({ name }) => name),
    ...columns.map(({ id }) => id).filter(isColumnExportable),
  ]);
}
